// Turns hand-written [[1]] / [[1]]: definition footnotes into
// Tufte-style sidenotes, on custom-text.hbs posts only (.text-article).
//
// This used to also handle a second, older convention -- 11 vol-4/vol-5
// full-moon posts pasted in as raw Substack-import HTML footnotes
// (<a class="footnote-anchor">/<div class="footnotes"><ol>) instead of
// this bracket syntax. scripts/normalize-footnotes.js rewrote all 11
// posts' stored content onto this convention (see that script and
// phase3_migration_decisions.md for the history), so that conversion
// path was removed here rather than carried forward as permanent
// tech debt for a content shape that no longer exists anywhere.
//
// Done client-side rather than as a one-time content rewrite: Ghost's
// HTML importer strips inline tags it doesn't recognize (label, input,
// span) back down to plain text on save, so hand-authored sidenote
// markup can't actually survive being saved as post content. Content
// stays exactly as authors already write it; this just re-renders it.

function buildSidenote(number, definitionHtml) {
    const label = document.createElement("label");
    label.setAttribute("for", `sn-${number}`);
    label.className = "margin-toggle sidenote-number";

    const input = document.createElement("input");
    input.type = "checkbox";
    input.id = `sn-${number}`;
    input.className = "margin-toggle";

    const span = document.createElement("span");
    span.className = "sidenote";
    span.innerHTML = definitionHtml;

    const fragment = document.createDocumentFragment();
    fragment.append(label, input, span);
    return fragment;
}

function convertBracketFootnotes(container) {
    const definitions = {};
    const definitionRe = /^\s*\[\[(\d+)\]\]:\s*/;

    Array.from(container.querySelectorAll(":scope > p")).forEach((p) => {
        const match = p.innerHTML.match(definitionRe);
        if (match) {
            definitions[match[1]] = p.innerHTML.slice(match[0].length);
            p.remove();
        }
    });

    if (!Object.keys(definitions).length) {
        return;
    }

    const markerRe = /\[\[(\d+)\]\]/g;
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    const targets = [];
    let node;
    while ((node = walker.nextNode())) {
        markerRe.lastIndex = 0;
        if (markerRe.test(node.nodeValue)) {
            targets.push(node);
        }
    }

    targets.forEach((textNode) => {
        const text = textNode.nodeValue;
        const fragment = document.createDocumentFragment();
        let lastIndex = 0;
        let match;

        markerRe.lastIndex = 0;
        while ((match = markerRe.exec(text))) {
            const before = text.slice(lastIndex, match.index);
            if (before) {
                fragment.appendChild(document.createTextNode(before));
            }

            const number = match[1];
            if (definitions[number]) {
                fragment.appendChild(buildSidenote(number, definitions[number]));
            } else {
                fragment.appendChild(document.createTextNode(match[0]));
            }

            lastIndex = match.index + match[0].length;
        }

        const rest = text.slice(lastIndex);
        if (rest) {
            fragment.appendChild(document.createTextNode(rest));
        }

        textNode.replaceWith(fragment);
    });
}

export default function sidenotes() {
    const container = document.querySelector(".text-article .gh-content");
    if (!container) {
        return;
    }

    convertBracketFootnotes(container);
}
